import { configureStore } from '@reduxjs/toolkit';
import loginReducer from './login';
import formsReducer from './forms';
import reserveReducer from './reserve';
import modelsReducer from './models';
import errorsReducer from './errors';
import cameraReducer from './camera';
import layoutReducer from './layout';
import themeReducer from './theme';

export default configureStore({
  reducer: {
  	login: loginReducer,
  	forms: formsReducer,
  	reserve: reserveReducer,
  	models: modelsReducer,
  	errors: errorsReducer,
	camera: cameraReducer,
	layout: layoutReducer,
	theme: themeReducer,
  }
});